<template>
  <v-container fluid>
    <section class="content-header">
      <v-toolbar dark dense color="#96298A">
        <v-toolbar-title>Indicadores</v-toolbar-title>
        <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-divider class="mx-4" vertical />
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="getIndicadores()"
                  x-large
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-cloud-refresh</v-icon>
                </v-btn>
              </template>
              <span>Actualizar Datos</span>
            </v-tooltip>
            <v-divider class="mx-4" vertical />
          </v-toolbar-items>
      </v-toolbar>
    </section>
    <v-tabs vertical background-color="blue-grey lighten-5" icons-and-text>
        <v-tab>
            Indicadores Generales
            <v-icon>mdi-speedometer</v-icon>
        </v-tab>
        <v-tab>
            Indicadores de Calidad
            <v-icon>mdi-timetable</v-icon>
        </v-tab>
        <v-tab-item>
            <v-card elevation="3">
                <v-row>
                    <v-col>
                        <div class="text-h5">Guías Pendientes por Cliente</div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col v-for="(pendiente,index) in pendientesCliente" :key="index" cols="2">
                        <v-card elevation="5" outlined rounded>
                            <v-toolbar dense dark color="orange darken-3" height="25">
                                <v-toolbar-title>{{pendiente.cliente}}</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-row>
                                    <v-col class="d-flex justify-left align-center">
                                        <v-icon size="60" color="blue">mdi-account-supervisor-circle-outline</v-icon>
                                    </v-col>
                                    <v-col class="d-flex justify-end align-center">
                                        <div class="text-h3">{{pendiente.total}}</div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <div class="text-h5">Guías Pendientes por Orden</div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col v-for="(pendiente,index) in pendientes" :key="index" cols="2">
                        <v-card elevation="5" outlined rounded>
                            <v-toolbar dense dark color="purple darken-3" height="25">
                                <v-toolbar-title>{{pendiente.guia_master}}</v-toolbar-title>
                            </v-toolbar>
                            <v-card-subtitle><strong>{{pendiente.cliente}}</strong></v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col class="d-flex justify-left align-center">
                                        <v-icon size="60" color="amber">mdi-airport</v-icon>
                                    </v-col>
                                    <v-col class="d-flex justify-end align-center">
                                        <div class="text-h3">{{pendiente.total}}</div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <div class="text-h5">Estatus Pendientes</div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col>
                        <apexchart
                            ref="chart"
                            type="bar"
                            height="350"
                            :options="chartOptions"
                            :series="series"
                        ></apexchart>
                    </v-col>
                </v-row>
            </v-card>
        </v-tab-item>
        <v-tab-item>
            <v-card elevation="3">
                <v-row dense>
                    <v-col>
                        <v-text-field
                        label="Desde"
                        v-model="desde"
                        type="date"
                        clearable
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                        label="Hasta"
                        v-model="hasta"
                        type="date"
                        clearable
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-combobox
                        label="Cliente"
                        :items="clientes"
                        v-model="cliente"
                        item-text="cliente"
                        item-value="cliente"
                        clearable
                        append-icon="mdi-account-circle"
                        ></v-combobox>
                    </v-col>
                    <v-col>
                      <v-combobox
                        label="Agente"
                        :items="agentes"
                        v-model="agente"
                        item-text="nombre"
                        item-value="id"
                        return-object
                        clearable
                        append-icon="mdi-account"
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                      <v-combobox
                          v-model="provincia"
                          :items="provincias"
                          item-text="provincia"
                          item-value="provincia"
                          label="Provincia"
                          return-object
                          clearable
                          append-icon="mdi-map-marker"
                        ></v-combobox>
                    </v-col>
                    <v-col>
                      <v-combobox
                          label="Depot"
                          :items="depots"
                          v-model="depot"
                          item-text="depot"
                          item-value="depot"
                          return-object
                          clearable
                          append-icon="mdi-map-check"
                          ></v-combobox>
                    </v-col>
                    <v-col>
                        <v-combobox
                        label="Proceso"
                        :items="procesos"
                        v-model="proceso"
                        item-text="text"
                        item-value="value"
                        clearable
                        append-icon="mdi-shield-refresh"
                        ></v-combobox>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Master"
                        v-model="master"
                        clearable
                        append-icon="mdi-file"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-btn color="primary" outlined @click="getGuiasRangoCalidad()">Generar <v-icon>mdi-refresh</v-icon></v-btn>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="3">
                        <v-card elevation="3" rounded outlined>
                            <v-card-subtitle>Ordenes</v-card-subtitle>
                            <v-card-text>
                                <v-list shaped>
                                    <v-list-item-group
                                        v-model="ordenesSelected"
                                        multiple
                                        @change="handleSelectOrden()"
                                    >
                                    <template v-for="(item, i) in ordenes">
                                        <v-list-item
                                        :key="`item-${i}`"
                                        :value="item"
                                        active-class="deep-purple--text text--accent-4"
                                        >
                                        <template v-slot:default="{ active }">
                                            <v-list-item-content>
                                            <v-list-item-title v-text="item"></v-list-item-title>
                                            </v-list-item-content>

                                            <v-list-item-action>
                                            <v-checkbox
                                                :input-value="active"
                                                color="deep-purple accent-4"
                                            ></v-checkbox>
                                            </v-list-item-action>
                                        </template>
                                        </v-list-item>
                                    </template>
                                    </v-list-item-group>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="9">
                        <v-card elevation="3" rounded outlined>
                            <v-card-subtitle>Indicadores</v-card-subtitle>
                            <v-card-text>
                                <v-card elevation="3">
                                    <v-card-title class="pa-0">Estatus General</v-card-title>
                                    <v-card-text>
                                        <v-row dense>
                                                <v-col cols="3" v-for="(est,index) in estatusOrdenLst" :key="index">
                                                    <v-card>
                                                        <v-toolbar dense dark color="orange darken-3" height="25">
                                                            <v-toolbar-title><div class="text-caption">{{est.estatus}}</div></v-toolbar-title>
                                                        </v-toolbar>
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col>
                                                                <div>{{est.total}}</div>
                                                                    <v-divider></v-divider>
                                                                <div>{{datosGuiasF.length}}</div>
                                                            </v-col>
                                                            <v-col>
                                                                <div>{{(Math.round((est.total / datosGuiasF.length) * 100)/100) * 100}}%</div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                    </v-card>
                                                </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                        <v-row dense>
                                                <v-col>
                                                <v-expansion-panels>
                                                    <v-expansion-panel>
                                                    <v-expansion-panel-header color="#96298A" class="white--text">
                                                        Grafica...
                                                        <template v-slot:actions>
                                                        <v-icon color="white">
                                                            mdi-menu-down
                                                        </v-icon>
                                                        </template>
                                                    </v-expansion-panel-header>
                                                    <v-expansion-panel-content>
                                                        <apexchart
                                                            ref="chart"
                                                            type="bar"
                                                            height="350"
                                                            :options="chartOptionsEst"
                                                            :series="seriesEst"
                                                        ></apexchart>
                                                    </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                </v-expansion-panels>
                                                </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card elevation="3">
                                    <v-card-title class="pa-0">Estatus por Depot</v-card-title>
                                    <v-card-text>
                                        <v-row dense v-for="(est,index) in depotOrdenLst" :key="index">
                                            <v-col>
                                                <v-expansion-panels>
                                                <v-expansion-panel>
                                                <v-expansion-panel-header color="#96298A" class="white--text">
                                                    {{est.depot}}
                                                    <template v-slot:actions>
                                                    <v-icon color="white">
                                                        mdi-menu-down
                                                    </v-icon>
                                                    </template>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-row>
                                                        <v-col cols="3" v-for="(es,i) in est.estatusList.filter((e) => e.estatus != null)" :key="i">
                                                            <v-card>
                                                                <v-toolbar dense dark color="orange darken-3" height="25">
                                                                    <v-toolbar-title><div class="text-caption">{{es != null ? es.estatus : ''}}</div></v-toolbar-title>
                                                                </v-toolbar>
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col>
                                                                        <div>{{es != null  ? es.total : 1}}</div>
                                                                            <v-divider></v-divider>
                                                                        <div>{{est.total}}</div>
                                                                    </v-col>
                                                                    <v-col>
                                                                        <div>{{(Math.round(((es != null  ? es.total : 1) / est.total) * 100)/100) * 100}}%</div>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card-text>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            </v-col>
                                    </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card elevation="3">
                                    <v-card-title class="pa-0">Distribución por Depot</v-card-title>
                                    <v-card-text>
                                        <v-row dense>
                                                <v-col cols="3" v-for="(est,index) in depotOrdenLst" :key="index">
                                                    <v-card>
                                                        <v-toolbar dense dark color="orange darken-3" height="25">
                                                            <v-toolbar-title><div class="text-caption">{{est.depot}}</div></v-toolbar-title>
                                                        </v-toolbar>
                                                    <v-card-text class="pa-0 mx-3">
                                                    <v-row dense>
                                                        <strong>Guias por Depot</strong>
                                                    </v-row>
                                                        <v-row dense>
                                                            <v-col>
                                                                <div>Depot: <strong>{{est.total}}</strong></div>
                                                                    <v-divider></v-divider>
                                                                <div>Total: <strong>{{datosGuiasF.length}}</strong></div>
                                                            </v-col>
                                                            <v-col>
                                                                <div><strong>{{(Math.round((est.total / datosGuiasF.length) * 100)/100) * 100}}%</strong></div>
                                                            </v-col>
                                                        </v-row>
                                                        <v-divider></v-divider>
                                                        <v-row dense>
                                                        <strong>Prom. Dias Entrega</strong>
                                                    </v-row>
                                                    <v-row dense>
                                                        <v-col>
                                                                <div>Tiempo: <strong>{{est.horasTransito}}</strong></div>
                                                                    <v-divider></v-divider>
                                                                <div>Entregadas: <strong>{{est.guiasEntregadas}}</strong></div>
                                                            </v-col>
                                                            <v-col>
                                                                <div>Prom: <strong>{{isNaN(Math.round((est.horasTransito / est.guiasEntregadas) * 100)/100) ? 0 : (Math.round((est.horasTransito / est.guiasEntregadas) * 100)/100) }} Hrs.</strong></div>
                                                            </v-col>
                                                    </v-row>
                                                    </v-card-text>
                                                    </v-card>
                                                </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                            <v-expansion-panels>
                                                <v-expansion-panel>
                                                <v-expansion-panel-header color="#96298A" class="white--text">
                                                    Grafica...
                                                    <template v-slot:actions>
                                                    <v-icon color="white">
                                                        mdi-menu-down
                                                    </v-icon>
                                                    </template>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <apexchart
                                                            type="pie"
                                                            :options="chartOptionsDep"
                                                            :series="seriesDep"
                                                        ></apexchart>
                                                </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            </v-col>
                                    </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card elevation="3">
                                    <v-card-title class="pa-0">Total de Envios y Pesos</v-card-title>
                                    <v-card-text>
                                        <v-row dense>
                                            <v-col cols="2">
                                                <v-card>
                                                    <v-toolbar dense dark color="orange darken-3" height="25">
                                                        <v-toolbar-title><div class="text-caption">General</div></v-toolbar-title>
                                                    </v-toolbar>
                                                    <v-card-text class="pa-0 mx-3">
                                                        <v-row dense>
                                                        <v-col>
                                                            <div>Total Envíos: <strong>{{datosGuiasF.length}}</strong></div>
                                                                <v-divider></v-divider>
                                                            <div>Total Pesos: <strong>{{(Math.round(datosGuiasF.reduce((pv,cv) => pv + parseFloat(cv.peso_kg),0) * 100)/100)}}</strong></div>
                                                        </v-col>
                                                    </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="2" v-for="(prov,index) in provinciasOrdenList" :key="index">
                                                    <v-card>
                                                        <v-toolbar dense dark color="orange darken-3" height="25">
                                                            <v-toolbar-title><div class="text-caption">{{prov.provincia}}</div></v-toolbar-title>
                                                        </v-toolbar>
                                                    <v-card-text class="pa-0 mx-3">
                                                        <v-row dense>
                                                            <v-col>
                                                                <div>Total Envíos: <strong>{{prov.envios}}</strong></div>
                                                                    <v-divider></v-divider>
                                                                <div>Total Pesos: <strong>{{(Math.round(prov.pesos * 100)/100)}}</strong></div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                    </v-card>
                                                </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import VueApexCharts from "vue-apexcharts";
export default {
    components:{
        apexchart: VueApexCharts,
    },
    data(){
        return{
            pendientes: [],
            pendientesCliente: [],
            agente: null,
            agentes: [],
            provincia: null,
            provincias: [],
            depots: [
                {depot: "GYE"},
                {depot: "UIO"},
                {depot: "ECO"},
            ],
            procesos: [
                {text: "Normal", value : 1},
                {text: "Con Novedad", value : 0},
            ],
            proceso: null,
            depot: null,
            master: null,
            series: [],
            seriesEst: [],
            seriesDep: [],
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 350
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true,
                        }
                    },
                    dataLabels: {
                        enabled: true
                    },
                    xaxis: {
                        categories: [],
                    },
                    fill:{

                        colors : ['#E65100','#96298A']
                    }
            },
            chartOptionsEst: {
                chart: {
                    type: 'bar',
                    height: 350
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true,
                        }
                    },
                    dataLabels: {
                        enabled: true
                    },
                    xaxis: {
                        categories: [],
                    },
                    fill:{

                        colors : ['#96298A']
                    }
            },
            chartOptionsDep: {
                chart: {
                    type: 'pie',
                    height: 350
                    },
                    plotOptions: {
                        pie: {
                            size: 200
                        }
                    },
                    labels: []
            },
            clientes: [],
            cliente: null,
            desde: null,
            hasta: null,
            todas: 'todas',
            ordenesSelected: [],
            ordenes: [],
            datosGuias: [],
            datosGuiasF: [],
            //Para Dashboard
            estatusOrdenLst: [],
            depotOrdenLst: [],
            provinciasOrdenList: [],
            tiempoTransito: {

            }
        }
    },
    methods:{
        getIndicadores:async function(){
                await apicon.getDataApi(apicon.getApiBaseUrl() + 'getindicadoresgen').then((result) => {
                    this.pendientes = result.pendientes;
                    this.setChartData(result.estatus);
                    this.gruopPendientesByCliente();
                })
            },
        getClientes: function(){
            apicon.getDataApi(apicon.getApiBaseUrl() + 'getclientescl').then((result) => {
                this.clientes = result;
            });
        },
        gruopPendientesByCliente: function(){
            var result = [];
            this.pendientes.reduce((res,value) => {
                if(!res[value.cliente]){
                    res[value.cliente] = {
                        cliente: value.cliente,
                        total: 0
                    }
                    result.push(res[value.cliente]);
                }
                res[value.cliente].total += value.total
                return res;
            },{});
            this.pendientesCliente = result;
        },
        setChartData: function(data){
            let dataCategories = []
            let dataSeries = []
            data.forEach(el => {
                if(el.estatus == null){
                    dataCategories.push("Sin Asignar");
                    dataSeries.push(el.total);
                }else{
                    dataCategories.push(el.estatus);
                    dataSeries.push(el.total);
                }
            });
            this.chartOptions = {
                ...this.chartOptions, ...{
                    xaxis : {
                        categories : dataCategories
                    }
                }
            }
            this.series = [{
                name: 'Pendientes',
                type: 'bar',
                data: dataSeries
            }]
        },
        setChartEst: function(data){
            let dataCategories = []
            let dataSeries = []
            data.forEach(el => {
                dataCategories.push(el.estatus);
                dataSeries.push(el.total);
            });
            this.chartOptionsEst = {
                ...this.chartOptionsEst, ...{
                    xaxis : {
                        categories : dataCategories
                    }
                }
            }
            this.seriesEst = [{
                name: 'Estatus',
                type: 'bar',
                data: dataSeries
            }]
        },
        setChartDep: function(data){
            let dataCategories = []
            let dataSeries = []
            data.forEach(el => {
                dataCategories.push(el.depot);
                dataSeries.push(el.total);
            });
            this.chartOptionsDep = {
                ...this.chartOptionsDep, ...{
                   labels : dataCategories
                }
            }
            this.seriesDep = dataSeries;
        },
        getGuiasRangoCalidad: async function(){
            await apicon.getDataApi(apicon.getApiBaseUrl() + 'getindicadorescal?' +
                    (this.desde != null ? '&desde=' + this.desde : '' ) +
                    (this.hasta != null ? '&hasta=' + this.hasta : '' ) +
                    (this.cliente != null ? '&cliente=' + this.cliente.cliente : '') +
                    (this.agente != null ? '&id_agente=' + this.agente.id : '') +
                    (this.provincia != null ? '&provincia=' + this.provincia.provincia : '') +
                    (this.depot != null ? '&depot=' + this.depot.depot : '') +
                    (this.proceso != null ? '&proceso=' + this.proceso.value : '') +
                    (this.master != null ? '&master=' + this.master : '')
                    ).then((result) => {
                        this.datosGuias = result;
                        this.getOrdenes();
                        this.handleSelectOrden();
            });
        },
        getOrdenes: function(){
            this.ordenes = [];
            var result = [];
            this.datosGuias.reduce((res,value) => {
                if(!res[value.guia_master]){
                    res[value.guia_master] = value.guia_master

                    result.push(res[value.guia_master]);
                }
                return res;
            },{});
            this.ordenes = result;
            this.ordenesSelected = result;
        },
        filterData: function(){
            this.datosGuiasF = this.datosGuias.filter(item => this.ordenesSelected.includes(item.guia_master));
        },
        setEstatusOrdenLst: function(){
            var result = [];
            this.datosGuiasF.reduce((res,value) => {
                if(!res[value.id_estatus]){
                    res[value.id_estatus] = {
                        estatus: value.estatus != null ? value.estatus.descripcion : "Sin Asignar",
                        total: 0
                    }
                    result.push(res[value.id_estatus]);
                }
                res[value.id_estatus].total += 1
                return res;
            },{});
            this.estatusOrdenLst = result;
        },
        /*setDepotOrdenLst: function(){
            var result = [];
            this.datosGuiasF.reduce((res,value) => {
                if(!res[value.depot]){
                    res[value.depot] = {
                        depot: value.depot != null ? value.depot : "Sin Asignar",
                        total: 0,

                    }
                    result.push(res[value.depot]);
                }
                res[value.depot].total += 1

                return res;
            },{});
            this.depotOrdenLst = result;
        },*/
        setPesosProvincia: function(){
          var result = [];
            this.datosGuiasF.reduce((res,value) => {
                if(!res[value.provincia]){
                    res[value.provincia] = {
                        provincia: value.provincia != null ? value.provincia : "Sin Asignar",
                        envios: 0,
                        pesos: 0,
                    }
                    result.push(res[value.provincia]);
                }
                res[value.provincia].envios += 1
                res[value.provincia].pesos += parseFloat(value.peso_kg != null ? value.peso_kg : 0)
                return res;
            },{});
            this.provinciasOrdenList = result;
        },
        setStatusDepot: function(){
            var result = [];
            this.datosGuiasF.reduce((res,value) => {
                if(!res[value.depot]){
                    res[value.depot] = {
                        depot: value.depot != null ? value.depot : "Sin Asignar",
                        total: 0,
                        guiasEntregadas: 0,
                        horasTransito: 0,
                        estatusList: [],
                    }
                    result.push(res[value.depot]);
                }
                res[value.depot].total += 1
                res[value.depot].guiasEntregadas += (value.tiempo_transito != null ? 1 : 0)
                res[value.depot].horasTransito += (value.tiempo_transito != null ? value.tiempo_transito : 0)
                if(!res[value.depot].estatusList[value.id_estatus != null ? value.id_estatus : 0]){
                  res[value.depot].estatusList[value.id_estatus != null ? value.id_estatus : 0] = {
                    estatus : value.estatus != null ? value.estatus.descripcion : "Sin Asignar",
                    total: 0
                  }
                }
                res[value.depot].estatusList[value.id_estatus != null ? value.id_estatus : 0] .total +=1;
                return res;
            },{});
            this.depotOrdenLst = result;
        },
        handleSelectOrden: function(){
            this.filterData();
            this.setEstatusOrdenLst();
            //this.setDepotOrdenLst();
            this.setStatusDepot();
            this.setPesosProvincia();
            this.setChartEst(this.estatusOrdenLst);
            this.setChartDep(this.depotOrdenLst);
        },
        getAgentes: async function(){
            await apicon.getDataApi(apicon.getApiBaseUrl() + 'agente').then((result) => {
                this.agentes = result;
            });
        },
        fillProvincias: async function () {
        await apicon
          .getDataApi(apicon.getApiBaseUrl() + "provinciasec")
          .then((result) => {
            this.provincias = result;
          });
      },
    },
    mounted: async function(){
        await apicon.setAuthHeaders();
        this.getIndicadores();
        this.getClientes();
        await this.getAgentes();
        await this.fillProvincias();
    }
}
</script>
